export const formatearMensajePlantilla = (
    mensajePlantilla,
    mensaje
) => {
    if (!mensajePlantilla) return "";

    let texto = mensajePlantilla;

    // 🔹 Función para detectar JSON válido
    const esJSON = (str) => {
        if (typeof str !== "string") return false;
        str = str.trim();
        if (!str.startsWith("{") && !str.startsWith("[")) return false;
        try {
            JSON.parse(str);
            return true;
        } catch {
            return false;
        }
    };

    // 1️⃣ Parsear variables SOLO si es JSON válido
    let variables = {};
    if (typeof mensaje === "object") {
        variables = mensaje;
    } else if (esJSON(mensaje)) {
        variables = JSON.parse(mensaje);
    } else {
        // ⚠️ no es JSON → no hacer nada (evita el error)
        variables = {};
    }

    // 2️⃣ Reemplazar *{{n}}* primero
    texto = texto.replace(/\*\{\{(\d+)\}\}\*/g, (_, key) => {
        return variables[key] ?? "";
    });

    // 3️⃣ Reemplazar {{n}} normales
    texto = texto.replace(/\{\{(\d+)\}\}/g, (_, key) => {
        return variables[key] ?? "";
    });

    // 4️⃣ Quitar asteriscos sobrantes
    texto = texto.replace(/\*/g, "");

    // 5️⃣ Convertir saltos de línea
    texto = texto
        .replace(/\\r\\n/g, "\n")
        .replace(/\\n/g, "\n")
        .replace(/\\r/g, "\n");

    return texto;
};